import React from "react";
import { getPasswordStrength } from "../utils/passwordStrength";

const PasswordStrength = ({ password }) => {
  if (!password) return <p style={{ margin: "6px 0", fontSize: 13, color: "#64748b" }}>Use 8+ characters with uppercase, lowercase, a number, and a special character.</p>;
  const strength = getPasswordStrength(password);
  return <div aria-live="polite" style={{ marginTop: 6, fontSize: 13 }}>
    <div style={{ fontWeight: 700, color: strength.color }}>Password strength: {strength.label}</div>
    <div style={{ height: 5, margin: "5px 0", borderRadius: 4, background: "#e2e8f0", overflow: "hidden" }}>
      <div style={{ width: `${strength.score * 20}%`, height: "100%", background: strength.color, transition: "width .2s" }} />
    </div>
    <ul style={{ margin: "4px 0 0", paddingLeft: 18, color: "#475569" }}>
      {strength.checks.map((check) => <li key={check.key} style={{ color: check.met ? "#15803d" : "#64748b" }}>{check.met ? "✓" : "○"} {check.label}</li>)}
    </ul>
  </div>;
};

export default PasswordStrength;
